// extracted by mini-css-extract-plugin
module.exports = {"alertWrapper":"AlertBox_alertWrapper__3AtW7","header":"AlertBox_header__1GY_8","error":"AlertBox_error__2Xyh-","alert":"AlertBox_alert__28TzW","button":"AlertBox_button__2tB-3"};